import { BrandsSelect } from "./BrandsSelect";
import { RequestNameInput } from "./RequestNameInput";
import { SelectDesignType } from "./SelectDesignType";

export function IntroSection() {
  return (
    <div className="flex flex-col gap-y-2xl lg:grid lg:grid-cols-4 lg:gap-x-3xl">
      <RequestNameInput />
      <SelectDesignType />
      <BrandsSelect />
    </div>
  );
}
